import { render, staticRenderFns } from "./member_group.vue?vue&type=template&id=48284c93&scoped=true&"
import script from "./member_group.vue?vue&type=script&lang=tsx&"
export * from "./member_group.vue?vue&type=script&lang=tsx&"
import style0 from "./member_group.vue?vue&type=style&index=0&id=48284c93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48284c93",
  null
  
)

export default component.exports